<template lang="pug">
page-layout#permits(
	:heading='heading'
	:num-of-slide-outs='1'
	:class='{ "above-side-nav" : permitPageState === "opened" }'
)
	.link-container(slot='link-container')
		// ? getting rid of the map reference since link leads no where.
		//- router-link.map(to='/app/map') View on Map
		//- a.alter(href='#') Alter Entry Settings
		.button(@click='permitForm') Add New Permit
	permit-slide-out(
		slot='slideout-1'
		:state='permitPageState'
		:asset='activePermit'
		:asset-key='permitKey'
		:is-new-permit='isNewPermit'
		asset-name='permits'
		@close='permitPageState = "closed"; activePermit = null;'
		@edit='editPermit'
		@delete='deletePermit'
	)
	asset-table(
		slot='content'
		asset-name='permits'
		asset-key='permitsKey'
		search-text='Search for a Permit'
		:config='config'
		:get-all='GetPermits'
		:get='GetPermit'
		:search='SearchPermits'
		:download-csv='DownloadPermitsCSV'
		:download-pdf='DownloadPermitsPDF'
		@row-clicked='viewPermit'
	)
</template>

<script>
import AssetTable from '@/components/AssetTable';
import PageLayout from '@/components/PageLayout';
import PermitSlideOut from '@/components/slide-outs/permits';

import {
	GetPermits,
	GetPermit,
	DeletePermit,
	DownloadPermitsCSV,
	DownloadPermitsPDF,
	SearchPermits
} from '@/lib/API';

import Submit from '@/lib/Submit';

import { editPermit } from '@/lib/generate';

import PermitsConfig from '@/lib/assets/permits';

export default {
	name : 'permits',

	data : () => ( {

		heading : {
			title       : 'Permits Reference',
			description : 'Click any row to view the permit information in full',
		},

		config : {
			columns : PermitsConfig.columns,

			// for if you have any columns that have a dropdown
			// for it's filtering
			dropdownOptions : PermitsConfig.dropdownOptions,
		},

		permitPageState : 'closed',
		activePermit    : null,
		isNewPermit     : false,
		permitKey       : null,

		GetPermits,
		GetPermit,
		DownloadPermitsCSV,
		DownloadPermitsPDF,
		SearchPermits

	} ),

	created() {
		const { query } = this.$route;
		const { key }   = query;

		if ( key ) {
			this.viewPermit( { permitsKey : key } );
		}
	},

	computed : {

		customMethods() {
			return {
				downloadCSV : DownloadPermitsCSV,
				downloadPDF : DownloadPermitsPDF,
				getAssets   : GetPermits,
				getAsset    : GetPermit,
				search      : SearchPermits,
			};
		}

	},

	methods : {

		permitForm() {
			this.$store.dispatch( 'form', {
				type : 'permit',
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Creating Permit...',
						state   : 'loading'
					} );

					Submit.permit( form )
						.then( ( permit ) => {
							const { permitsKey } = permit.permit;

							return this.viewPermit( { permitsKey, isNew : true } );
						} )
						.then( () => form.close() )
						.then( () => stateIndicator.resolve( 'Created Successfully' ) )
						.catch( ( err ) => {
							console.warn( err );
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Create Permit', message : '' } );
						} );
				} );
		},

		viewPermit( { permitsKey, isNew = false } ) {

			this.activePermit = null;
			this.permitKey    = null;
			this.isNewPermit  = isNew;

			this.permitPageState = 'opened';

			const displayStateOptions = {
				message        : 'Loading Permit',
				successMessage : 'Permit Loaded',
				failMessage    : 'Permit could not be loaded.',
				state          : 'loading',
			};

			this.$store.dispatch( 'loadWithDisplayState', {
				options : displayStateOptions,
				method  : () => GetPermit( permitsKey ),
			} )
				.then( ( permit ) => {
					this.activePermit = permit;
					this.permitKey    = permit.permitsKey;
				} );

		},

		closePermit() {
			this.permitPageState = 'closed';
			this.activePermit    = null;
		},

		editPermit() {
			const { permitsKey, location } = this.activePermit;

			if ( location ) this.activePermit.locationDescription = location.description;
			else this.activePermit.locationDescription = ' ';

			if ( this.activePermit.location ) delete this.activePermit.location;

			console.log( 'activePermit', this.activePermit );

			const startingData   = editPermit( this.activePermit );

			this.$store.dispatch( 'form', {
				type : 'permit',
				args : [{ edit : true }],
				startingData,
			} )
				.then( async ( form ) => {

					const stateIndicator = await this.$store.dispatch( 'displayState', {
						message : 'Editing Permit...',
						state   : 'loading'
					} );

					Submit.editPermit( form, permitsKey )
						.then( () => form.close() )
						.then( () => stateIndicator.resolve( 'Edited Successfully' ) )
						.catch( () => {
							form.close();
							stateIndicator.fail( { header : 'Didn\'t Edit Permit', message : '' } );
						} );
				} );
		},

		async deletePermit() {

			const stateIndicator = await this.$store.dispatch( 'displayState', {
				message : 'Deleting Permit...',
				state   : 'loading'
			} );

			DeletePermit( this.activePermit.permitsKey )
				.then( () => stateIndicator.resolve( 'Deleted Successfully' ) )
				.then( this.permitPageState = 'closed' )
				.catch( ( err ) => {

					console.error( err );

					stateIndicator.fail( { header : 'Didn\'t Delete Permit', message : '' } );

				} );

		},

	},

	components : {
		AssetTable,
		PageLayout,
		PermitSlideOut,
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.space-form.permit-form {
	@include set-form-color( #8089BA );

	.form-label {

		p {
			text-align: center;

			&:last-of-type {
				font-size: 14px;
				color: $input-color-faded;
			}
		}
	}

	.drop-box-wrapper {

		.background {
			background: lighten( #8089BA, 30% );
		}

		.display-text {
			margin: 0 0 28px 0;
		}
	}
}
</style>
